import PlayersRanking from './PlayersRankingList';

export default PlayersRanking;
